import { onUnmounted } from "vue";

type Listener = (ev: FocusEvent) => void;

export function useBlur(listener: Listener) {

  const abortController = new AbortController();

  window.addEventListener('blur', listener, {
    signal: abortController.signal
  });

  onUnmounted(() => {
    abortController.abort();
  });
}
